import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title>{props.title || 'Arrow-Fill-Down'}</title>
      <g>
        <path d="M263.8 438.1c-2.3 2.9-5.3 4.1-8.2 4.1s-6.5-1.2-8.2-4.1l-242.9-295.8c-2.4-2.9-2.9-7-1.2-11.2 1.8-3.5 5.3-5.9 9.4-5.9h485.9c4.1 0 7.6 2.3 9.4 5.9 1.8 4.1 1.2 8.2-1.2 11.2l-243 295.8z" />
      </g>
    </Icon>
  )
}
